import styled from 'styled-components';

export const CompanyButtonContainer = styled.div.attrs({})`
  width: 100%;
  display: flex;
  gap: 16px;
`;

export const AddProposalContainer = styled.div.attrs({})`
  padding: 20px 0px;
`;

export const FonteLink = styled.div.attrs({})`
    width: 100%;
    display: flex;
    gap: 16px;
    padding: 12px;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    color: #a0a0a0
    &:hover {
        color: #333333;
        background-color: #faf8f8;
    }
    &:active{
        color: #ffffff
        background-color: #2670D1;
    }
`;

export const ButtonsAndInputWrapper = styled.div.attrs({})`
  display: grid;
  gap: 20px;
`;
